import axios from 'axios';
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import core from '../../core';
import "./Booking.css"
import { Pagination, Stack } from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { Search, Plus, Download, ThreeDotsVertical, Funnel } from 'react-bootstrap-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button, Modal } from 'react-bootstrap';
import AddNewBooking from './AddNewBooking';
import { notificationActions } from '../../data/notification';
import useViewMode from '../../hooks/useViewMode';
import ViewToggle from '../../components/DataView/ViewToggle';
import DataCards from '../../components/DataView/DataCards';
import useT from '../../i18n/useT';

const Booking = () => {
    const t = useT();
    const [filter, setFilter] = useState({keyword: "", start_date: "", end_date: "", limit: 10, page: 1, loading_port: "", line: "", asc: "desc", sort_by: "id"})
    const [booking, setBooking] = useState([]);
    const [paginator, setPaginator] = useState({from: 0, to: 0, total: 0, pages: 1});
    const [loading, setLoading] = useState(false);
    const lang = useSelector((state) => state.user.language);
    const [keyword, setKeyword] = useState("");
    const [showDateSelector, setShowDateSelector] = useState(false);
    const [dates, setDates] = useState({start_date: "", end_date: ""});
    const [showFilters, setShowFilters] = useState(false);
    const [bookingForm, setBookingForm] = useState({});
    const [showBooking, setShowBooking] = useState(false);
    const [actionType, setActionType] = useState("add");
    const [formLoader, setFormLoader] = useState(false);
    const [actionsId, setActionsId] = useState("");
    const [showConfirmationModal ,setShowConfirmationModal] = useState(false);
    const dispatch = useDispatch();
    const {view, setView, isMobile} = useViewMode("booking-view");

    const rowActions = (book) => (
        <div className='table-actions-block'>
            <ThreeDotsVertical height={"19px"} onClick={() => setActionsId(book.id)} style={{cursor: "pointer"}}/>
            {actionsId === book.id && <OutsideClickHandler onOutsideClick={() => setActionsId("")}>
                <div className='table-actions-dropdown'>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setActionType("edit");
                        setBookingForm({...book});
                        setShowBooking(true);
                    }}>{t("common.edit")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setBookingForm({...book});
                        setShowConfirmationModal(true);
                    }}>{t("common.delete")}</div>
                </div>
            </OutsideClickHandler>}
        </div>
    );

    const cardFields = [
        {label: t("booking.buyer"), value: (b) => b.buyer_fullname},
        {label: t("booking.booking"), value: (b) => b.booking_number},
        {label: t("booking.line"), value: (b) => b.line},
        {label: t("booking.container"), value: (b) => b.container},
        {label: t("booking.delivery"), value: (b) => b.delivery_location},
        {label: t("booking.loadingPort"), value: (b) => b.loading_port},
        {label: t("booking.loaded"), value: (b) => b.container_loaded_date ? core.formdatDate(b.container_loaded_date, "yyyy-mm-dd") : t("table.noData")},
        {label: t("booking.received"), value: (b) => b.container_receive_date ? core.formdatDate(b.container_receive_date, "yyyy-mm-dd") : t("table.noData")},
        {label: t("booking.terminal"), value: (b) => b.terminal},
        {label: t("booking.estOpening"), value: (b) => b.est_opening_date ? core.formdatDate(b.est_opening_date, "yyyy-mm-dd") : t("table.noData")},
        {label: t("booking.opening"), value: (b) => b.open_date ? core.formdatDate(b.open_date, "yyyy-mm-dd") : t("table.noData")},
    ];

    const handlers = {
        createBooking(e){
            e.preventDefault();
            setFormLoader(true);
            axios.post('/api/booking', bookingForm)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShowBooking(false);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        updateBooking(e){
            e.preventDefault();
            setFormLoader(true);
            axios.put(`/api/booking/${bookingForm.id}`, bookingForm)
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShowBooking(false);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        deleteBooking(){
            setFormLoader(true);
            axios.delete(`/api/booking/${bookingForm.id}`, {data: {vin: bookingForm.vin}})
                .then((res) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setShowBooking(false);
                })
                .catch((err) => {
                    setFormLoader(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/booking?limit=${filter.limit}&page=${filter.page}&keyword=${filter.keyword}&asc=${filter.asc}&start_date=${filter.start_date}&end_date=${filter.end_date}&sort_by=${filter.sort_by}&loading_port=${filter.loading_port}&line=${filter.line}`)
            .then((res) => {
                setLoading(false);
                setBooking(res.data.data);
                const fromItems = ((filter.page - 1) * filter.limit) + 1;
                const toItems = res.data.total < filter.page * filter.limit ? res.data.total :  filter.page * filter.limit;
                const pagesCount = res.data.total % filter.limit === 0 ? res.data.total / filter.limit : parseInt((res.data.total / filter.limit) + 1);
                setPaginator({from: fromItems, to: toItems, total: res.data.total, pages: pagesCount});
            })
            .catch((err) => {

            })
    }, [filter]);

    return(
        <div className="page-content-main-container">
            <h2 className="page-title">{t("booking.title")}</h2>
            <div className="table-filter-container">
                <div className='data-table-filteres'>
                    <Button onClick={() => setShowFilters(true)} variant='primary' style={{marginRight: "15px", color: "white", display: "flex", alignItems: "center"}}><Funnel style={{fontSize: "20px", fontWeight: "bold", marginRight: "6px"}} /> <span>{t("common.filters")}</span></Button>
                    {showFilters && <OutsideClickHandler onOutsideClick={() => setShowFilters(false)}>
                        <div className='data-table-filters-dropdown'>
                            <div className='filter-selects'>
                                <select className='form-control' value={filter.sort_by} onChange={(e) => setFilter((prev) => ({...prev, sort_by: e.target.value}))}>
                                    <option value={"id"}>{t("common.sortBy")}</option>
                                    <option value={"container_loaded_date"}>{t("booking.containerLoadedDate")}</option>
                                    <option value={"container_receive_date"}>{t("booking.containerReceiveDate")}</option>
                                    <option value={"est_opening_date"}>{t("booking.estimatedOpeningDate")}</option>
                                    <option value={"open_date"}>{t("booking.openDate")}</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' value={filter.asc} onChange={(e) => setFilter((prev) => ({...prev, asc: e.target.value}))}>
                                    <option value={""}>{t("booking.oldToNew")}</option>
                                    <option value={"desc"}>{t("booking.newToOld")}</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' onChange={(e) => setFilter((prev) => ({...prev, booking: e.target.value}))}>
                                    <option value={""}>{t("booking.filterPort")}</option>
                                    <option value={"Port of WA Washington"}>Port of WA Washington</option>
                                    <option value={"Port of CA California"}>Port of CA California</option>
                                    <option value={"Port of TX Texas"}>Port of TX Texas</option>
                                    <option value={"Port of GA Georgia"}>Port of GA Georgia</option>
                                    <option value={"Port of NJ New Jersey"}>Port of NJ New Jersey</option>
                                </select>
                            </div>
                            <div className='filter-selects'>
                                <select className='form-control' onChange={(e) => setFilter((prev) => ({...prev, line: e.target.value}))}>
                                    <option value={""}>{t("booking.selectLine")}</option>
                                    <option value={"Evergreen"}>Evergreen</option>
                                    <option value={"Maersk"}>Maersk</option>
                                    <option value={"MSC"}>MSC</option>
                                    <option value={"Hapag-Lloyd"}>Hapag-Lloyd</option>
                                    <option value={"CMA CGM"}>CMA CGM</option>
                                    <option value={"ONE"}>ONE</option>
                                    <option value={"COSCO"}>COSCO</option>
                                    <option value={"ZIM"}>ZIM</option>
                                    <option value={"TURKON"}>TURKON</option>
                                </select>
                            </div>
                            <div className='date-selector-dropdown-container'>
                                <div className='date-selector-button' onClick={() => setShowDateSelector(!showDateSelector)}>{t("common.selectDate")}</div>
                                {showDateSelector && <OutsideClickHandler onOutsideClick={() => setShowDateSelector(false)}>
                                    <div className='date-selector-dropdown'>
                                        <div className='date-selector' style={{marginTop: "0px"}}>
                                            <span>{t("common.startDate")}</span>
                                            <input value={dates.start_date} type='date' onChange={(e) => setDates((prev) => ({...prev, start_date: e.target.value}))} className='form-control'/>
                                        </div>
                                        <div className='date-selector'>
                                            <span>{t("common.endDate")}</span>
                                            <input value={dates.end_date} type='date' className='form-control' onChange={(e) => setDates((prev) => ({...prev, end_date: e.target.value}))}/>
                                        </div>
                                        <Button onClick={() => setFilter((prev) => ({...prev, start_date: dates.start_date, end_date: dates.end_date}))} style={{width: "200px", marginTop: "15px"}}>{t("common.confirmDate")}</Button>
                                        <Button variant='danger' onClick={() => {
                                            setFilter((prev) => ({...prev, start_date: "", end_date: ""}));
                                            setDates({start_date: "", end_date: ''});
                                        }} style={{width: "200px", marginTop: "15px"}}>{t("common.clearDate")}</Button>
                                    </div>
                                </OutsideClickHandler>}
                            </div>
                        </div>    
                    </OutsideClickHandler>}
                </div>
                <ViewToggle view={view} setView={setView} isMobile={isMobile} />
                <button className='btn btn-primary mr-3' style={{marginRight: "15px", marginLeft: "15px", display: "flex", alignItems: "center"}} onClick={() => {
                    const qs = `keyword=${encodeURIComponent(filter.keyword)}&start_date=${filter.start_date}&end_date=${filter.end_date}&loading_port=${filter.loading_port}&line=${filter.line}`;
                    window.open(`/api/booking/export?${qs}`, "_blank");
                }}><Download style={{fontSize: "20px", fontWeight: "bold", marginRight: "6px"}}/> <span>{t("common.export")}</span></button>
                <Button variant='primary' onClick={() => {
                    setShowBooking(true);
                    setActionType("add");
                    setBookingForm({});
                }} style={{display: "flex", alignItems: "center", marginRight: "15px"}}><Plus style={{fontSize: "20px", fontWeight: "bold"}} /> <span>{t("common.addNew")}</span></Button>
                <div className='search-by-keyword'>
                    <input placeholder={t("common.search")} type='text' onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            setFilter((prev) => ({...prev, keyword: keyword}));
                        }
                    }} value={keyword} className='form-control' onChange={(e) => setKeyword(e.target.value)} />
                    <button onClick={() => setFilter((prev) => ({...prev, keyword: keyword}))}><Search /></button>
                </div>
            </div>
            {view === "table" ? (
            <Table responsive>
                <thead>
                    <tr>
                        <th>VIN</th>
                        <th>{t("booking.buyer")}</th>
                        <th>{t("booking.booking")}</th>
                        <th>{t("booking.line")}</th>
                        <th>{t("booking.container")}</th>
                        <th>{t("booking.deliveryLocation")}</th>
                        <th>{t("booking.loadingPort")}</th>
                        <th>{t("booking.containerLoadedDate")}</th>
                        <th>{t("booking.containerReceiveDate")}</th>
                        <th>{t("booking.terminal")}</th>
                        <th>{t("booking.estimatedOpeningDate")}</th>
                        <th>{t("booking.openingDate")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading && <tr><td colSpan={13}><div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><div className="loader" role=""></div></div></td></tr>
                    }
                    {
                        (booking.length > 0 && !loading) && booking.map((book) => {
                            return(
                                <tr key={book.id}>
                                    <td>{book.vin}</td>
                                    <td>{book.buyer_fullname}</td>
                                    <td>{book.booking_number}</td>
                                    <td>{book.line}</td>
                                    <td>{book.container}</td>
                                    <td>{book.delivery_location}</td>
                                    <td>{book.loading_port}</td>
                                    <td>{book.container_loaded_date !== null ? core.formdatDate(book.container_loaded_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{book.container_receive_date !== null ? core.formdatDate(book.container_receive_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{book.terminal}</td>
                                    <td>{book.est_opening_date !== null ? core.formdatDate(book.est_opening_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{book.open_date !== null ? core.formdatDate(book.open_date, "yyyy-mm-dd") : t("table.noData")}</td>
                                    <td>{rowActions(book)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!loading && booking.length === 0) && <tr><td colSpan={13} style={{textAlign: "center"}}>{t("table.notFound")}</td></tr>
                    }
                </tbody>
            </Table>
            ) : (
                <DataCards layout={view}
                    items={loading ? [] : booking}
                    loading={loading}
                    getKey={(b) => b.id}
                    renderTitle={(b) => b.vin}
                    renderSubtitle={(b) => b.buyer_fullname}
                    fields={cardFields}
                    renderActions={(b) => rowActions(b)}
                />
            )}
            <div className="pagination-container">
                <div className="paginatior-left-size">
                    <p className="showing-items-text">{t("table.showing")} {paginator.from} {t("table.of")} {paginator.to}</p>
                    <span style={{margin: "0 12px"}}>{t("table.total")}: {paginator.total}</span>
                    <span>{t("table.show")}:</span>
                    <select value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))} className="form-control" style={{width: "50px"}}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <Stack spacing={2}>
                    <Pagination count={paginator.pages} page={filter.page} onChange={(value, p) => setFilter((prev)=>({...prev, page: p}))} />
                </Stack>
            </div>
            <AddNewBooking loading={formLoader} formData={bookingForm} setFormData={setBookingForm} show={showBooking} setShow={setShowBooking} submit={actionType == "add" ? handlers.createBooking : handlers.updateBooking} type={actionType} />
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} >
                <Modal.Header closeButton><h3>{t("booking.removeTitle")}</h3></Modal.Header>
                <Modal.Body><p>{t("booking.removeConfirm")}</p></Modal.Body>
                <Modal.Footer>
                    <Button type='button' onClick={handlers.deleteBooking} variant={formLoader ? 'secondary' : 'primary'} disabled={formLoader}>{formLoader ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.yes")}</Button>
                    <Button type='button' onClick={() => setShowConfirmationModal(false)} variant='danger'>{t("common.no")}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Booking